type SexesObject = {
  [key: string]: string
}

export const SEXES_OBJECT: SexesObject = {
  M: 'Masculino',
  F: 'Feminino',
  N: 'Neutro',
  UNKNOWM: 'Desconhecido',
}
